import * as React from 'react';

import moment, { Moment } from 'moment';
import { useRef, useState } from 'react';

import { IMultiSelectOption } from '../../interfaces/ILookup';

export interface IDateInputControlProps {
    additionalStyleClass?: string;
    item: IMultiSelectOption;
    onChange: (e: React.ChangeEvent<HTMLInputElement>, item: IMultiSelectOption) => void;
    onInputError?: (item: IMultiSelectOption, errorMessage: string) => void;
    value: string;
}

export function DateInputControl(props: IDateInputControlProps) {
    const inputRef = useRef<HTMLInputElement>(null);

    const { additionalStyleClass, item, onChange, value } = props;

    const [localValue, setLocalValue] = React.useState<string>(value);

    const validate = () => {
        const input = inputRef.current;
        if (!input) return;

        if (input.validity.badInput) {
            props.onInputError?.(item, input.validationMessage);
        } else {
            props.onInputError?.(item, '');
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLocalValue(e.target.value);
        validate();
        onChange(e, item);
        validate();
    };

    React.useEffect(() => {
        setLocalValue(value);
    }, [value]);

    return (
        <input
            type="date"
            className={`form-control ${additionalStyleClass} ${!!localValue ? '' : ' unselectClass'}`}
            value={localValue}
            onChange={handleInputChange}
            onBlur={handleInputChange}
            ref={inputRef}
        />
    );
}
